import {toRaw} from "vue";

export const SortReportArr = (data, field) => {
    let arr = toRaw(data.value);
    return arr.sort(function (a, b) {
        return b[field] - a[field];
    });
}